export default __webpack_public_path__ + "static/media/Deed of Contract_12.9bf781f2.jpg";